module.exports = __webpack_public_path__ + "img/v4_configKvStoreList.3c2f232e.png";